import { render, staticRenderFns } from "./RewardPoint.vue?vue&type=template&id=d00b4686&"
import script from "./RewardPoint.vue?vue&type=script&lang=js&"
export * from "./RewardPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports